import { render } from "./caseDetail.vue?vue&type=template&id=17ba83cb"
import script from "./caseDetail.vue?vue&type=script&lang=js"
export * from "./caseDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\zytdwl\\zytdwl_cms\\zytdwl_cms\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__